<template>
  <div class="input-container">
    <validation-observer ref="contract"
                         tag="form"
                         @submit.prevent="submitContract">
      <div class="input-wrapper">
        <v-popover placement="left">
          <img class="info-icon"
               src="/assets/images/tooltip.svg"
               alt="info-icon">
          <template slot="popover">
            <img src="/assets/images/customer_id.png"
                 alt="info-image-customer-id">
          </template>
        </v-popover>
        <base-v-input :label="$t('checkout.existingCable.userCode')"
                      type="number"
                      name="userPass"
                      v-model="setUserPass"
                      maxlength="20"
                      pattern="\d*"
                      rules="required|max:20"/>
      </div>
      <div class="input-wrapper">
        <v-popover placement="left">
          <img class="info-icon"
               src="/assets/images/tooltip.svg"
               alt="info-icon">
          <template slot="popover">
            <img src="/assets/images/account_image.png"
                 alt="info-image-account">
          </template>
        </v-popover>
        <base-v-input :label="$t('checkout.existingCable.contractNumber')"
                      type="number"
                      name="contractNumber"
                      v-model="setContractNumber"
                      maxlength="20"
                      pattern="\d*"
                      rules="required|max:20"/>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import BaseVInput from '@/components/base/base-v-input'

export default {
  name: 'existing-cable',
  components: { BaseVInput },
  props: {
    userPass: String,
    contractNumber: String
  },
  computed: {
    setUserPass: {
      get () {
        return this.$props.userPass
      },
      set (val) {
        this.$emit('user-pass', val)
      }
    },
    setContractNumber: {
      get () {
        return this.$props.contractNumber
      },
      set (val) {
        this.$emit('contract-number', val)
      }
    }
  },
  methods: {
    async submitContract () {
      const valid = await this.$refs.contract.validate()
      if (valid) {
        this.$emit('submit-cable')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-container {
  margin-top: 3rem;

  > form {
    @media (map_get($breakpoints, sm)) {
      display: flex;
      margin: 0 -1.2rem;
    }
  }
}

.input-wrapper {
  @media (map_get($breakpoints, sm)) {
    flex: 0 0 calc(50% - 2.4rem);
    margin: 0 1.2rem;
  }

  .v-popover {
    float: right;
    position: relative;
    z-index: 1;
    cursor: pointer;
  }
}
</style>
